var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#F5F7F9"}},[_c('v-main',{staticStyle:{"background-color":"#F5F7F9"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath + '|' + _vm.$tz.display()})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }